/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopScheduleAlertResponseSchema = z.object({
  alertType: z.enum(['PENDING_RESCHEDULE']),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  loopId: z.int(),
});
